// constants
import { MealSlot } from '@local/typedefs/dist/protos/campaign/MealSlot';
import { DayOfWeek } from '@local/typedefs/dist/protos/google/DayofWeek';
export const MealSlotMap = {
    [MealSlot.MEAL_SLOT_EARLY_BREAKFAST]: {
        label: 'Early Breakfast',
        time: '(03:00 am - 07:00 am)',
    },
    [MealSlot.MEAL_SLOT_BREAKFAST]: {
        label: 'Breakfast',
        time: '(07:00 am - 11:00 am)',
    },
    [MealSlot.MEAL_SLOT_LUNCH]: {
        label: 'Lunch',
        time: '(11:00 am - 03:00 pm)',
    },
    [MealSlot.MEAL_SLOT_SNACKS]: {
        label: 'Snacks',
        time: '(03:00 pm - 07:00 pm)',
    },
    [MealSlot.MEAL_SLOT_DINNER]: {
        label: 'Dinner',
        time: '(07:00 pm - 11:00 pm)',
    },
    [MealSlot.MEAL_SLOT_LATE_DINNER]: {
        label: 'Late Night',
        time: '(11:00 pm - 03:00 am)',
    },
    [MealSlot.MEAL_SLOT_INVALID]: {
        label: 'Invalid',
        time: 'None',
    },
};
export const MEAL_SLOT_OPTIONS = [
    {
        key: MealSlotMap[MealSlot.MEAL_SLOT_EARLY_BREAKFAST].label,
        timeLabel: MealSlotMap[MealSlot.MEAL_SLOT_EARLY_BREAKFAST].time,
        value: MealSlot.MEAL_SLOT_EARLY_BREAKFAST,
    },
    {
        key: MealSlotMap[MealSlot.MEAL_SLOT_BREAKFAST].label,
        timeLabel: MealSlotMap[MealSlot.MEAL_SLOT_BREAKFAST].time,
        value: MealSlot.MEAL_SLOT_BREAKFAST,
    },
    {
        key: MealSlotMap[MealSlot.MEAL_SLOT_LUNCH].label,
        timeLabel: MealSlotMap[MealSlot.MEAL_SLOT_LUNCH].time,
        value: MealSlot.MEAL_SLOT_LUNCH,
    },
    {
        key: MealSlotMap[MealSlot.MEAL_SLOT_SNACKS].label,
        timeLabel: MealSlotMap[MealSlot.MEAL_SLOT_SNACKS].time,
        value: MealSlot.MEAL_SLOT_SNACKS,
    },
    {
        key: MealSlotMap[MealSlot.MEAL_SLOT_DINNER].label,
        timeLabel: MealSlotMap[MealSlot.MEAL_SLOT_DINNER].time,
        value: MealSlot.MEAL_SLOT_DINNER,
    },
    {
        key: MealSlotMap[MealSlot.MEAL_SLOT_LATE_DINNER].label,
        timeLabel: MealSlotMap[MealSlot.MEAL_SLOT_LATE_DINNER].time,
        value: MealSlot.MEAL_SLOT_LATE_DINNER,
    },
];
export const DaysOfWeekMap = {
    [DayOfWeek.MONDAY]: {
        label: 'Monday',
    },
    [DayOfWeek.TUESDAY]: {
        label: 'Tuesday',
    },
    [DayOfWeek.WEDNESDAY]: {
        label: 'Wednesday',
    },
    [DayOfWeek.THURSDAY]: {
        label: 'Thursday',
    },
    [DayOfWeek.FRIDAY]: {
        label: 'Friday',
    },
    [DayOfWeek.SATURDAY]: {
        label: 'Saturday',
    },
    [DayOfWeek.SUNDAY]: {
        label: 'Sunday',
    },
    [DayOfWeek.DAY_OF_WEEK_UNSPECIFIED]: {
        label: 'None',
    },
};
export const DAY_OF_WEEK_OPTIONS = [
    {
        key: DaysOfWeekMap[DayOfWeek.MONDAY].label,
        value: DayOfWeek.MONDAY,
    },
    {
        key: DaysOfWeekMap[DayOfWeek.TUESDAY].label,
        value: DayOfWeek.TUESDAY,
    },
    {
        key: DaysOfWeekMap[DayOfWeek.WEDNESDAY].label,
        value: DayOfWeek.WEDNESDAY,
    },
    {
        key: DaysOfWeekMap[DayOfWeek.THURSDAY].label,
        value: DayOfWeek.THURSDAY,
    },
    {
        key: DaysOfWeekMap[DayOfWeek.FRIDAY].label,
        value: DayOfWeek.FRIDAY,
    },
    {
        key: DaysOfWeekMap[DayOfWeek.SATURDAY].label,
        value: DayOfWeek.SATURDAY,
    },
    {
        key: DaysOfWeekMap[DayOfWeek.SUNDAY].label,
        value: DayOfWeek.SUNDAY,
    },
];
export const PERFORMANCE_SUMMARY_TABLE_COLUMNS = [
    {
        title: 'Last Week',
        sortable: true,
        key: 'dateRange',
        width: '25%',
    },
    {
        title: 'Impressions',
        sortable: true,
        width: '25%',
        key: 'impressionCount',
    },
    {
        title: 'Cart Additions',
        sortable: true,
        width: '25%',
        key: 'addToCart',
    },
    {
        title: 'GMV',
        sortable: true,
        width: '25%',
        key: 'gmv',
    },
    {
        title: 'ROI',
        sortable: true,
        width: '25%',
        key: 'roi',
    },
];
export const NULL = 'null';
